import {Translation} from './Translation';

const language: Translation = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    create: 'Create',
    created: 'Created',
    join: 'Join',
    leave: 'Leave',
    draft: 'Draft',
    drafts: 'Drafts',
    accept: 'Accept',
    decline: 'Decline',
    continue: 'Continue',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    with: 'with',
    at: 'at',
    from: 'from',
    to: 'to',
    date: 'Date',
    time: 'Time',
    location: 'Location',
    details: 'Details',
    chat: 'Chat',
    tasks: 'Tasks',
    participants: 'Participants',
    attendees: 'Attendees',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    title: 'Title',
    description: 'Description',
    required: 'Required',
    optional: 'Optional',
    gettingStarted: 'Getting Started',
    invalid: 'Invalid',
    valid: 'Valid',
    empty: 'Empty',
    notFound: 'Not Found',
    notAvailable: 'Not Available',
    comingSoon: 'Coming Soon',
    download: 'Download',
    upload: 'Upload',
    share: 'Share',
    copy: 'Copy',
    refresh: 'Refresh',
    retry: 'Retry',
    tryAgain: 'Try Again',
    somethingWentWrong: 'Something went wrong',
    invalidCredentials: 'Invalid credentials',
    accessDenied: 'Access denied',
    permissionDenied: 'Permission denied',
    networkError: 'Network error',
    serverError: 'Server error',
    unknownError: 'Unknown error',
    start: 'Start',
    creating: 'Creating...',
    user: 'User',
    language: 'Language',
    notifications: 'Notifications',
    reminder: 'Reminder',
    reminders: 'Reminders',
    published: 'Published',
    enableNotifications: 'Enable notifications',
    emailNotifications: 'Email notifications',
    pushNotifications: 'Push notifications',
    unlimitedColleagues: 'Unlimited colleagues',
    colleague: 'colleague',
    colleagues: 'colleagues',
    peopleRange: 'people',
    profile: 'Profile',
    firstName: 'First name',
    of: 'of',
    lastName: 'Last name',
    fullName: 'Full name',
    bio: 'Bio',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    today: 'Today',
    tomorrow: 'Tomorrow',
    days: 'days ago',
    weeks: 'weeks ago',
    selected: 'selected',
    more: 'more',
    status: 'Status',
    interests: 'Interests',
    searchPlaceholder: 'Search by name, email, job title, or interests...',
    clearAll: 'Clear All',
    selectInterestsToFilter: 'Select interests to filter by:',
    downloadToCalendar: 'Download to calendar',
    manuallyAddEmployee: 'Manually add employee',
    addEmployeeToEvent: 'Add Employee to Event',
    addEmployee: 'Add Employee',
    noEmployeesFound: 'No employees found matching your search.',
    noAvailableEmployees: 'No available employees to add.',
    noColleaguesFound: 'No colleagues found matching your search.',
    noColleaguesAvailable: 'No colleagues available to invite.',
    searchEmployeesPlaceholder:
      'Search by name, email, job title, or department...',
    searchColleaguesPlaceholder:
      'Search by name, email, job title, or department...',
    addOption: 'Add option',
    avatar: 'Avatar',
    nameAndTitle: 'Name & Title',
    department: 'Department',
    jobTitle: 'Job title',
    company: 'Company',
    officeLocation: 'Office Location',
    started: 'Started',
    funFact: 'Fun Fact',
    cards: 'Cards',
    table: 'Table',
    loadingInterests: 'Loading interests...',
    noInterestsFound: 'No interests found.',
    searchInterests: 'Search interests...',
    cantFindWhatYoureLookingFor: "Can't find what you're looking for?",
    teamOnboarding: 'Team Onboarding',
    loadingOnboardingProgress: 'Loading onboarding progress...',
    failedToLoadOnboardingData: 'Failed to load onboarding data',
    unableToLoadOnboardingData: 'Unable to load onboarding data',
    teamMembersActive: 'team members active',
    activeMembers: 'Active Members',
    active: 'Active',
    pendingInvites: 'Pending Invites',
    pendingInvitesClickToView: 'Pending Invites (Click to view)',
    trackTeamOnboardingProgress:
      "Track your team's onboarding progress and see who still needs to join.",
    allTeamMembersJoined: '🎉 All team members have joined!',
    almostThereMostTeamOnboard:
      '🚀 Almost there! Most of your team is onboard.',
    goodProgressMoreThanHalf:
      '📈 Good progress! More than half of your team has joined.',
    teamMembersStillJoining:
      '📨 Team members are still joining. Invites are pending.',
    gettingStartedTeamGrowing: '🌱 Getting started! Your team is growing.',
    loadingPendingInvites: 'Loading pending invites...',
    noPendingInvitesFound: 'No pending invites found.',
    theseTeamMembersInvited:
      "These team members have been invited but haven't joined yet. You can resend their invitation.",
    invited: 'Invited',
    recently: 'recently',
    sending: 'Sending...',
    reInvite: 'Re-invite',
    topInterests: 'Top Interests',
    noInterestDataAvailable: 'No interest data available',
    changeEmoji: 'Change emoji',
    pickEmoji: 'Pick emoji',
    noEmojiSelected: 'No emoji selected...',
    whatNeedsToBeDone: 'What needs to be done?',
    createTask: 'Create Task',
    inviteEmployees: 'Invite Employees',
    inviteMessage: 'Invite message',
    enterCustomInviteMessage: 'Enter your custom invite message...',
    addEmailsWithCSVOrManually: 'Add employees via CSV',
    downloadExampleCSV: 'Download Example CSV',
    processingCSVFile: 'Processing CSV file...',
    dragAndDropCSVFileHere: 'Drag and drop a CSV file here, or click',
    orEnterEmailAddress: 'Or enter employee details manually',
    add: 'Add',
    emailsToInvite: 'Emails to invite',
    employeesToInvite: 'Employees to invite',
    actions: 'Actions',
    invite: 'Invite',
    users: 'users',
    pleaseEnterValidEmailAddress: 'Please enter a valid email address',
    pleaseFillRequiredFields: 'Please fill in all required fields',
    emailDomainNotAllowed: 'Email domain is not allowed. Allowed domains:',
    allowedDomains: 'Allowed domains:',
    thisEmailAlreadyInList: 'This email is already in the list',
    noValidEmailsFoundInCSV: 'No valid emails found in the CSV file',
    emailsRemovedBecauseNotMatch:
      'emails removed because they did not match the allowed domains:',
    was: 'was',
    were: 'were',
    itDid: 'it did',
    theyDid: 'they did',
    notMatchAllowedDomains: 'not match the allowed domains:',
    orWereDuplicates: 'or were duplicates',
    errorParsingCSVFile: 'Error parsing CSV file',
    failedToInviteUsers: 'Failed to invite users',
    pendingInvitations: 'Pending invitations',
    invitedAt: 'Invited At',
    invitedBy: 'Invited By',
    selectOrTypeDepartments: 'Select or type departments...',
    ifNoDepartmentsSelectedEveryoneInvited:
      'If no departments are selected, everyone will be invited',
    allDepartmentsSelectedEveryoneInvited:
      'All departments selected, everyone will be invited',
    moveToDeclined: 'Move to Declined',
    moveToAttending: 'Move to Attending',
    nonRespondents: 'Non Respondents',
    confirmMoveToDeclined: 'Move to Declined?',
    confirmMoveToDeclinedMessage:
      'Are you sure you want to manually move {firstName} to declined?',
    confirmMoveToAttending: 'Move to Attending?',
    confirmMoveToAttendingMessage:
      'Are you sure you want to manually move {firstName} to attending?',
  },
  auth: {
    signIn: 'Welcome',
    signOut: 'Sign out',
    signUp: 'Sign up',
    signUpWithEmail: 'Sign up with email',
    welcomeBack: 'Welcome back',
    welcome: 'Welcome',
    verifyEmailWaiting: 'Verifying email...',
    enterEmail: 'Email',
    enterPassword: 'Password',
    createPassword: 'Create a password',
    confirmPasswordLabel: 'Confirm password',
    passwordsDoNotMatch: 'Passwords do not match',
    emailPlaceholder: 'myname@email.com',
    passwordPlaceholder: 'Enter password',
    continueWithEmail: 'Continue',
    signInWithEmail: 'Sign in with email',
    signInWithGoogle: 'Sign in with Google',
    continueWithSSO: 'Continue with SSO',
    chooseSignInMethod: 'Choose your sign-in method',
    organizationId: 'Organization ID',
    organizationIdPlaceholder: 'Enter your organization ID',
    cannotBeLeftBlank: 'Cannot be left blank',
    notValidEmail: 'Not a valid email',
    notValidPassword: 'Not a valid password',
    somethingWentWrongSSO:
      'Something went wrong trying to sign you in with single-sign on',
    errorSigningIn: 'Error signing in',
    errorSigningUp: 'Error signing up',
    logout: 'Logout',
    invalidCredentials: 'Invalid credentials',
    emailNotAllowedForSignup:
      "You can't sign up with this email. Please contact your administrator.",
    signingUpForCompany: 'Signing up for {companyName}',
    verifyEmailTitle: 'Check your inbox',
    verifyEmailDescription:
      'We just sent you a verification link. Open the email to confirm your account.',
    verifyEmailSentTo: 'Sent to {email}',
    verifyEmailCompanyLine:
      'Once verified, we will finish setting up your {companyName} access.',
    verifyEmailCta: 'Back to login',
  },
  navigation: {
    dashboard: 'Dashboard',
    createEvent: 'Create Hubbl Event',
    employeeOverview: 'Employee overview',
    eventsOverview: 'Events overview',
    interestAnalytics: 'Interest Analytics',
    eventAnalytics: 'Event Analytics',
    settings: 'Settings',
    general: 'General',
    profile: 'Profile',
    slackIntegration: 'Slack Integration',
    integrations: 'Integrations',
    adminManagement: 'Admin Management',
    viewingAs: 'Viewing as',
    admin: 'Admin',
    employee: 'Employee',
    home: 'Home',
    createHubbl: 'Create Hubbl',
    colleagues: 'Colleagues',
    previousEvents: 'Previous Events',
  },
  dashboard: {
    welcome: 'Welcome',
    welcomeDescription: "See below for what's happening at",
    socialActivities: 'Social Activities',
    noSocialActivities: 'No social activities',
    noActivitiesMatchFilters:
      'No activities match your current filters. Try adjusting your filter settings above.',
    loadingSocialActivities: 'Loading your social activities...',
    myOwn: 'My Own',
    accepted: 'Accepted',
    declined: 'Declined',
    pending: 'Pending',
    completed: 'Completed',
    onboardingProgress: 'Setup Progress',
    inviteColleagues: 'Invite Colleagues',
    createFirstEvent: 'Create First Event',
    integrateSlackTeams: 'Integrate Slack/Teams',
    connectCalendar: 'Connect Calendar',
    stepsCompleted: '{completed} of {total} steps completed',
    allStepsCompleted: 'All set! Your Hubbl workspace is fully configured!',
    clickToComplete: 'Click to complete',
    createYourFirstEvent: 'Create Your First Event',
    createFirstEventDescription:
      'Get started by creating your first event to engage your team and build workplace connections.',
    eventTipsTitle: 'Event Tips',
    eventTipsDescription:
      'Set up reminders for better attendance and use tags to organize your events.',
    noEventsYet: 'No events yet',
    noEventsDescription:
      'Create your first event to start engaging your team and tracking analytics.',
    eventTip1:
      'Automated reminders target only non-responders, reducing spam and improving attendance rates.',
    eventTip2:
      'Add mandatory pre-event questions to collect dietary needs and preferences before RSVP.',
    eventTip3:
      'Use AI to generate complete event details, questions, and descriptions in seconds.',
    eventTip4: 'Enable QR code check-ins for fast, contactless event entry.',
    eventTip5:
      'Integrate with Slack and Teams to send event notifications directly to your team channels.',
    eventTip6:
      'Export all responses and analytics to CSV with one click for easy sharing with caterers.',
  },
  activities: {
    groupActivity: 'Group Activity',
    connect: 'Connect',
    event: 'Event',
    announcement: 'Announcement',
    groupNotFound: 'Group Not Found',
    connectNotFound: 'Connect Not Found',
    eventNotFound: 'Event Not Found',
    loading: 'Loading...',
    join: 'Join',
    leave: 'Leave',
    accept: 'Accept',
    decline: 'Decline',
    clickToAccept: 'Click to Accept',
    completed: '✓ Completed',
    declined: '✗ Declined - Click to Change',
    declinedClickToChange: '✗ Declined - Click to Change',
    tasksNotAvailable: 'Tasks Not Available',
    needToJoinForTasks: 'You need to join this group to access the tasks.',
    needToAcceptForTasks:
      'You need to accept this Connect to access the tasks.',
    chatNotAvailable: 'Chat Not Available',
    downloadApp: 'Download the Hubbl app',
    scanQRCode: 'Scan this QR code with your phone to download the app',
    declineActivity: 'Decline',
    declineActivityMessage:
      'Are you sure you want to decline this group activity?',
    leaveActivity: 'Leave Activity',
    leaveActivityMessage: 'Are you sure you want to leave this group activity?',
    declineConnect: 'Decline Connect',
    declineConnectMessage: 'Are you sure you want to decline this Connect?',
    keepInvitation: 'Keep invitation',
    stayInActivity: 'Stay in activity',
    joined: 'Attending',
    groupAttendees: 'Group Attendees',
    you: 'YOU',
    clickToSeeAll: 'Click to see all attendees',
    customActivity: 'Custom Activity',
  },
  events: {
    createEvent: 'Create Group Activity',
    createEventDescription: 'Create a group activity for your colleagues',
    createHubblEvent: 'Create Hubbl Event',
    createHubblEventDescription:
      'Here, you can create a new event at {companyName}.',
    editEvent: 'Edit Event',
    eventDetails: 'Event Details',
    activityDetails: 'Activity Details',
    activityRequired: 'Activity is required',
    whoCanSeeThis: 'Who can see this activity?',
    visibilityFilters: 'Visibility Filters',
    invitedUsers: 'Invited Users',
    recurring: 'Recurring',
    goBack: 'Go Back',
    type: 'Type',
    startTime: 'Start Time',
    endTime: 'End Time',
    maxParticipants: 'Max Participants',
    additionalDetails: 'Additional Details',
    tasks: 'Tasks',
    noTasksYet: 'No tasks yet',
    pressEnterToCreate: 'Press Enter to create',
    groupNotFound: 'Group Not Found',
    groupActivity: 'Group Activity',
    connectNotFound: 'Connect Not Found',
    clickToAccept: 'Click to Accept',
    tasksNotAvailable: 'Tasks Not Available',
    declineActivity: 'Decline',
    declineActivityMessage:
      'Are you sure you want to decline this group activity?',
    leaveActivity: 'Leave Activity',
    leaveActivityMessage: 'Are you sure you want to leave this group activity?',
    keepInvitation: 'Keep invitation',
    stayInActivity: 'Stay in activity',
    declineConnect: 'Decline Connect',
    declineConnectMessage: 'Are you sure you want to decline this Connect?',
    createActivity: 'Create Activity',
    chatNotAvailable: 'Chat Not Available',
    downloadApp: 'Download the Hubbl app',
    scanQRCode: 'Scan this QR code with your phone to download the app',
    createConnectDescription: 'Create a break to Connect with a colleague',
    startDateTimeRequired: 'Start date and time is required',
    addTasks: 'Add tasks',
    selectActivity: 'Select Activity',
    chooseActivityOrCreate: 'Choose an activity or create your own',
    orCreateYourOwn: 'Or create your own',
    writeCustomActivity: 'Write your custom activity',
    clickToViewUserProfile: 'Click to view user profile',
    viewProfile: 'View Profile',
    department: 'Department',
    company: 'Company',
    officeLocation: 'Office Location',
    started: 'Started',
    interests: 'Interests',
    unassign: 'Unassign',
    assignMyself: 'Assign myself',
    assignOthers: 'Assign others',
    willBeAssignedLater: 'Will be assigned later',
    unassigned: 'Unassigned',
    previewDescription: 'This is how your activity will look to colleagues:',
    preview: 'Preview',
    unlimited: 'Unlimited',
    willBeRecurringActivity: 'This will be a recurring activity',
    deadlinePassed: 'Deadline passed',
    rsvpToday: 'RSVP Today',
    rsvpTomorrow: 'RSVP Tomorrow',
    rsvpInDays: 'RSVP in {days} days',
    rsvpInOneHour: 'RSVP in 1 hour',
    rsvpInHours: 'RSVP in {hours} hours',
    rsvpInOneMinute: 'RSVP in 1 minute',
    rsvpInMinutes: 'RSVP in {minutes} minutes',
    rsvpInSeconds: 'RSVP in {seconds} seconds',
    noDeadline: 'No deadline',
    comingSoon: 'Coming Soon',
    groupChatComingSoon:
      "🚧 We're still building the web group chat experience! Our developers are working hard to bring you the same amazing group chat features you love on mobile. In the meantime, grab your phone and keep the conversation going with your {count} colleagues! 📱✨",
    connectChatComingSoon:
      "🚧 We're still building the web chat experience! Our developers are working hard to bring you the same amazing chat features you love on mobile. In the meantime, grab your phone and keep the conversation going! 📱✨",
    answerQuestions: 'Answer Questions',
    enterYourAnswer: 'Enter your answer',
    enterAdditionalComments: 'Enter additional comments',
    user: 'User',
    checkedInAt: 'Checked in at',
    declinedAt: 'Declined at',
    extraInfo: 'Extra Info',
    maxParticipantsDescription:
      'Set the maximum number of participants for this activity',
    declineEvent: 'Decline',
    declineEventMessage: 'Are you sure you want to decline this event?',
    leaveEvent: 'Leave Event',
    leaveEventMessage: 'Are you sure you want to leave this event?',
    stayInEvent: 'Stay in event',
    createOneOnOneConnection: 'Create 1-on-1 Connection',
    dateAndTime: 'Date & Time',
    endOptional: 'End (optional)',
    tasksDescription:
      'Do you need to delegate any tasks amongst you and your colleague?',
    tasksOptional: 'Tasks (optional)',
    makeRecurringActivity: 'Make this a recurring activity',
    createConnection: 'Create Connection',
    colleaguesAttended: 'colleagues attended',
    colleaguesAttending: 'colleagues attending',
    attendedThankYou: '✓ Attended - Thank you for your review!',
    reviewRequired: '📝 Review Required - Click to Review',
    attended: '✓ Attended',
    attending: '✓ Attending',
    declinedClickToChange: '✗ Declined - Click to Change',
    eventPassed: 'Event passed',
    join: 'Join',
    attendees: 'Attendees',
    invited: 'Invited',
    event: 'Event',
    upcoming: 'Upcoming',
    completed: 'Completed',
    deadline: 'Deadline',
    dayOfEvent: 'Day of event',
    eventEnd: 'Event End',
    evaluationEnd: 'Evaluation End',
    evaluationReminder: 'Eval Reminder',
    eventNotFound: 'Event Not Found',
    noLocationSpecified: 'No location specified',
    checkedIn: 'Checked in',
    notCheckedIn: 'Not checked in',
    deleteEvent: 'Delete Event',
    deleteEventTitle: 'Delete Event?',
    deleteEventMessage:
      'Are you sure you want to delete this event? This action cannot be undone and all attendees will be notified.',
    deleteEventSuccess: 'Event deleted successfully',
    deleteEventError: 'Failed to delete event',
  },
  filters: {
    filters: 'Filters',
    status: 'Status:',
    types: 'Types:',
    search: 'Search',
    searchPlaceholder: 'Search activities, people, or locations...',
    closeSearch: 'Close search',
    all: 'All',
    myOwn: 'My Own',
    pending: 'Pending',
    accepted: 'Accepted',
    declined: 'Declined',
    events: 'Events',
    groups: 'Groups',
    connects: 'Connects',
    startMonth: 'Start Month',
    endMonth: 'End Month',
    organizationalFilters: 'Organizational Filters',
    resetFilters: 'Reset Filters',
    applyFilters: 'Apply Filters',
  },
  analytics: {
    interestAnalytics: 'Interest Analytics',
    eventAnalytics: 'Event Analytics',
    eventAnalyticsTitle: 'Event Analytics',
    eventAnalyticsDescription: 'Insights for {companyName} events',
    insightsForCompany: 'Insights for {companyName}',
    failedToLoadEventAnalytics: 'Failed to load event analytics',
    csv: 'CSV',
    pdf: 'PDF',
    eventAnalyticsReport: 'Event Analytics Report',
    interestAnalyticsReport: 'Interest Analytics Report',
    generating: 'Generating...',
    errorGeneratingPDF: 'Error generating PDF. Please try again.',
    metric: 'Metric',
    value: 'Value',
    totalUsers: 'Total Users',
    usersWithInterests: 'Users with Interests',
    interestCompletionRate: 'Interest Completion Rate (%)',
    averageInterestsPerUser: 'Average Interests per User',
    interestDistribution: 'Interest Distribution',
    topInterests: 'Top Interests',
    interest: 'Interest',
    count: 'Count',
    percentage: 'Percentage',
    generatedOn: 'Generated on:',
    executiveSummary: 'Executive Summary',
    visualAnalytics: 'Visual Analytics',
    interestDistributionBreakdown: 'Interest Distribution Breakdown',
    interestRange: 'Interest Range',
    zeroInterests: '0 interests',
    oneToFiveInterests: '1-5 interests',
    sixToTenInterests: '6-10 interests',
    tenToTwentyInterests: '10-20 interests',
    twentyPlusInterests: '20+ interests',
    userCount: 'User Count',
    percentageOfTotal: 'Percentage of Total',
    mostPopularInterests: 'Most Popular Interests',
    selectionCount: 'Selection Count',
    reportGeneratedBy:
      'Report generated by WorkBreak Interest Analytics Dashboard',
    filteredBy: 'Filtered by:',
    allLocations: 'All Locations',
    allCompanies: 'All Companies',
    allDepartments: 'All Departments',
    selectedDepartments: 'Selected Departments',
    company: 'Company:',
    totalEvents: 'Total Events',
    avgResponseRate: 'Avg Response Rate',
    evaluationRate: 'Evaluation Rate',
    evaluationResponseRate: 'Evaluation Response Rate',
    sendEvaluationReminder: 'Send Evaluation Reminder',
    totalAttendees: 'Total Attendees',
    eventPerformanceOverview: 'Event Performance Overview',
    event: 'Event',
    date: 'Date',
    attendees: 'Attendees',
    responseRate: 'Response Rate',
    satisfaction: 'Satisfaction',
    organizationalBreakdown: 'Organizational Breakdown',
    department: 'Department',
    location: 'Location',
    events: 'Events',
    eventId: 'Event ID',
    eventTitle: 'Event Title',
    eventEmoji: 'Event Emoji',
    startDate: 'Start Date',
    endDate: 'End Date',
    totalInvited: 'Total Invited',
    totalDeclined: 'Total Declined',
    totalNoResponse: 'Total No Response',
    responseRatePercent: 'Response Rate (%)',
    evaluationCompletionRatePercent: 'Evaluation Completion Rate (%)',
    averageSatisfactionScore: 'Average Satisfaction Score',
    hasEvaluation: 'Has Evaluation',
    evaluationQuestions: 'Evaluation Questions',
    evaluationResponses: 'Evaluation Responses',
    tags: 'Tags',
    yes: 'Yes',
    no: 'No',
    organizationalInterestHeatmap: 'Organizational Interest Heatmap',
    filterByLocation: 'Filter by Location',
    filterByCompany: 'Filter by Company',
    filterByDepartments: 'Filter by Departments',
    popularInterestsAcrossDepartments:
      'Popular Interests Across Selected Departments',
    clickInterestToSeeEmployees:
      'Click on any interest to see which employees selected it across the filtered departments',
    // Heatmap specific translations
    high: 'High',
    mediumHigh: 'Medium-High',
    medium: 'Medium',
    low: 'Low',
    veryLow: 'Very Low',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selected: 'Selected',
    basedOnDepartments:
      'Based on {count} department{plural} with {totalUsers} total employees',
    topInterestsLabel: 'Top interests:',
    heatmapDescription:
      'Shows interest engagement rates across different organizational units. Higher rates indicate more active interest selection in those departments. Click on any department card to see the interests in that department.',
    // Interest trends chart
    month: 'Month',
    interestTrendsDescription:
      'Shows how interest engagement has changed over time. Interest completion rate indicates the percentage of users who have selected interests.',
    // Event details
    failedToAddEmployeeToEvent: 'Failed to add employee to event:',
    interestTrendsOverTime: 'Interest Trends Over Time',
    interestDistributionAcrossUsers: 'Interest Distribution Across Users',
    noInterestsFoundForDepartment: 'No interests found for this department',
    interestCategoriesDistribution: 'Interest Categories Distribution',
    allInterests: 'All Interests',
    totalInterests: 'total interests',
    viewAllInterests: 'View All Interests',
    clickBarToSeeEmployees:
      'Click on any bar to see which employees selected that interest',
    top10MostPopularInterests: 'Top 10 Most Popular Interests',
    eventsCreatedInPeriod: 'Events created in this period',
    averageResponseRate: 'Average response rate',
    topEvent: 'Top Event',
    noEvents: 'No events',
    noEventsToDisplay: 'No events to display',
    evaluationCompletionRate: 'Evaluation completion rate',
    upcomingEvents: 'Upcoming Events',
    eventsScheduledAhead: 'Events scheduled ahead',
    error: 'Error',
    // Event Analytics specific keys
    evaluationAnalytics: 'Evaluation Analytics',
    evaluationDescription:
      'Understanding how well events are evaluated and what feedback reveals about employee satisfaction.',
    totalEvaluations: 'Total Evaluations',
    eventsWithEvaluationForms: 'Events with evaluation forms',
    completedEvaluations: 'Completed Evaluations',
    evaluationsWithResponses: 'Evaluations with responses',
    evaluationCoverage: 'Evaluation Coverage',
    questionResponseRate: 'Question Response Rate',
    averageCompletionRate: 'Average completion rate',
    outOfFiveStars: 'Out of 5.0 stars',
    evaluationBreakdown: 'Evaluation Breakdown',
    eventsWithEvaluations: 'Events with Evaluations',
    ofTotalEvents: 'of total events',
    eventsWithoutEvaluations: 'Events without Evaluations',
    completionRate: 'Completion Rate',
    averageEvaluationCompletion: 'Average evaluation completion',
    responseQuality: 'Response Quality',
    excellent: 'Excellent',
    good: 'Good',
    needsImprovement: 'Needs Improvement',
    last3Months: 'Last 3 Months',
    currentPeriod: 'Current Period',
    scheduled: 'Scheduled',
    bestPerformance: 'Best Performance',
    basedOnSatisfactionScores: 'Based on satisfaction scores',
    responseRateTrends: 'Response Rate Trends',
    responseRateDescription:
      'Shows how response rates have changed over time. Higher rates indicate better employee engagement with events.',
    monthlyEventActivity: 'Monthly Event Activity',
    monthlyEventDescription:
      'Displays event creation patterns and attendance trends by month. Events (left axis) and attendees (right axis) use separate scales for better visibility.',
    quickStats: 'Quick Stats',
    averageAttendees: 'Average Attendees',
    eventPerformance: 'Event Performance',
    topDepartments: 'Top Departments',
    scanned: 'Scanned',
    noShow: 'No Show',
    invited: 'Invited',
    evaluation: 'Evaluation',
    qrCodes: 'QR Codes',
    status: 'Status',
    upcoming: 'Upcoming',
    completed: 'Completed',
    cards: 'Cards',
    table: 'Table',
    eventAnalyticsNotAvailable: '📊 Event Analytics Not Available',
    eventAnalyticsNotSetUp:
      "Event analytics haven't been set up for your company yet.",
    clickToGenerateAnalytics:
      'Click the button below to process all existing event data and generate analytics.',
    generateAnalytics: 'Generate Analytics',
    processingMayTakeTime:
      'This may take a few minutes depending on the number of events in your company.',
    eventAnalyticsMinimumRequirement:
      'Event Analytics will be enabled once you have 5 events that have passed.',
    interestAnalyticsMinimumRequirement:
      'Interest Analytics will be enabled once you have 15 employees who have signed up.',
    interestAnalyticsMinimumRequirementTitle: 'More employees needed',
    interestAnalyticsMinimumRequirementDescription:
      "Interest Analytics requires at least 15 employees to provide meaningful insights. Once you reach this threshold, you'll be able to see detailed analytics about your team's interests and preferences.",
    organizationalEventInsights: 'Organizational Event Insights',
    organizationalEventDescription:
      'Understanding how different departments engage with company events and identifying collaboration opportunities.',
    departmentsAnalyzed: 'Departments Analyzed',
    totalOrganizationalUnitsWithEventData:
      'Total organizational units with event data',
    acrossAllDepartments: 'Across all departments',
    mostActiveDepartment: 'Most Active Department',
    eventsOrganized: 'events organized',
    departmentPerformance: 'Department Performance',
    response: 'response',
  },
  modals: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    join: 'Join',
    leave: 'Leave',
    accept: 'Accept',
    decline: 'Decline',
  },
  forms: {
    required: 'Required',
    optional: 'Optional',
    invalid: 'Invalid',
    valid: 'Valid',
    cannotBeLeftBlank: 'Cannot be left blank',
    notValidEmail: 'Not a valid email',
    notValidPassword: 'Not a valid password',
    emailPlaceholder: 'myname@email.com',
    passwordPlaceholder: 'Enter password',
    namePlaceholder: 'Enter name',
    titlePlaceholder: 'Enter title',
    descriptionPlaceholder: 'Enter description',
  },
  buttons: {
    continue: 'Continue',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    join: 'Join',
    leave: 'Leave',
    accept: 'Accept',
    decline: 'Decline',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    download: 'Download',
    upload: 'Upload',
    share: 'Share',
    copy: 'Copy',
    refresh: 'Refresh',
    retry: 'Retry',
    tryAgain: 'Try Again',
    submit: 'Submit',
    loadMore: 'Load more',
  },
  ai: {
    getAISuggestion: 'Get AI suggestion',
    prompt: {
      title: 'Generate Event with AI',
      subtitle:
        "Describe your event, we craft the rest (e.g., 'Summer party June 25th')",
      placeholder: 'Describe your event in natural language...',
      triggerLabel: 'Generate with AI',
      showExamples: 'Show examples',
      hideExamples: 'Hide examples',
      generate: 'Generate',
      generating: 'Generating...',
      examples: [
        'Summer party, June 25th next year from 18:00 to 22:00, deadline is 15 May.',
        'Team building lunch next Month at 12pm in the cafeteria',
        'Quarterly all-hands meeting',
        'Friday bar, next month, deadline a week before',
        'Christmas party, 3 hours, December 15th',
        'Coffee break social for engineering team tomorrow',
        'Wellness workshop, 90 minutes in February, from 10am to 11:30am',
      ],
      clear: 'Clear',
      detailedGeneration: 'Detailed Generation',
      detailedGenerationDescription: 'Slower, but more detailed',
      fastGeneration: 'Fast Generation',
      fastGenerationDescription: 'Quick, but less detailed',
      generatingCoverImage: 'AI generating cover image...',
      generatingField: 'AI generating...',
    },
    imageGeneration: {
      title: 'AI Image Generation',
      placeholder:
        "Describe the cover image you want to generate (e.g., 'Modern office meeting room with glass walls and natural lighting')",
      clear: 'Clear',
      generateImage: 'Generate Image',
      generating: 'Generating...',
      keyboardShortcut: 'Press Cmd/Ctrl + Enter to generate',
      tooltip: {
        generate: 'Generate AI cover image',
        hide: 'Hide AI image generator',
      },
    },
  },
  interests: {
    requestNewInterest: 'Request new interest',
    newInterestRequestSubject: '💡 New Interest Request',
    newInterestRequestBody:
      "Hi team Hubbl 👋,\n\nI couldn't find the interest I was looking for in the Hubbl app. Could you please add:\n\nInterest: [Please describe the interest you'd like to see added]\nCategory: [Which category should this belong to?]\n\nThanks!",
  },
  invite: {
    inviteMessage:
      'You have been invited to join {companyName} on Hubbl! Connect with your colleagues, discover shared interests, and build meaningful relationships through fun activities and events.',
  },
  visibility: {
    editVisibility: 'Edit visibility',
    saveVisibility: 'Save visibility',
    cancel: 'Cancel',
    noVisibilityRestrictions:
      'No visibility restrictions - event will be visible to all employees',
  },
  attendees: {
    morePerson: 'more person',
    people: 'people',
  },
  questions: {
    myResponses: 'My question responses',
    noResponse: 'No response provided',
    required: 'Required',
    requiredMessage: 'This question is required',
    questionResponses: 'Question Responses',
    attendingUsers: 'Attending Users',
    unrespondedEmails: 'Unresponded users',
    noUnrespondedEmails: 'No unresponded users',
    evaluationRespondents: 'Evaluation Respondents',
    nonRespondents: 'Non-Respondents',
  },
  evaluation: {
    eventEvaluation: 'Event Evaluation',
    noEvaluationConfigured: 'No evaluation configured for this event.',
    evaluationDetails: 'Evaluation Details',
    evaluationLink: 'Evaluation Link',
    copyLink: 'Copy Link',
    copied: 'Copied!',
    evaluationQuestions: 'Evaluation Questions',
    evaluationReminders: 'Evaluation Reminders',
    noQuestionsConfigured: 'No questions configured',
    noRemindersConfigured: 'No reminders configured',
    evaluationResponses: 'Evaluation Responses',
    questionNumber: 'Question {number}',
    noResponsesYet: 'No responses yet',
    aggregatedResponses: 'Aggregated Responses',
    numberOfResponses: 'Number of Responses',
    thankYou: 'Thank you for your review',
    feedbackHelpful: 'Your feedback helps us improve future events!',
    review: 'Review',
    required: 'Required',
    requiredMessage: 'This question is required',
    enterAnswer: 'Enter your answer',
    additionalComments: 'Enter any additional comments',
    back: 'Back',
    submit: 'Submit',
    next: 'Next',
    pleaseEvaluateEvent: 'Please take a moment to evaluate this event.',
    evaluationReminder: 'Evaluation Reminder',
    evaluationReminderBody:
      'Hi,\n\nThis is a friendly reminder to complete the evaluation for the event "{eventTitle}" {eventEmoji}.\n\nYour feedback is important to us and helps us improve future events.\n\nPlease click here to complete the evaluation:\n{evaluationLink}\n\nBest regards,\n{adminName}',
    evaluationResponseCount: 'of {totalCount} attendees responded',
    showMoreResponses: 'Show {count} more responses',
    showLessResponses: 'Show less',
  },
  groups: {
    colleaguesAttended: 'colleagues attended',
    colleagues: 'colleagues',
    waitingForOthers: 'You created this - Waiting for others to join',
    joinedViewDetails: '✓ Joined - View Details',
    declinedClickToChange: '✗ Declined - Click to Change',
    completedViewDetails: '✓ Completed - View Details',
    join: 'Join',
  },
  connects: {
    acceptedYour: 'accepted your',
    youCreated: 'you created',
    with: 'with',
    waitingForSomeone: '(waiting for someone to join)',
    oneOnOneConnect: '1-on-1 Connect',
    connectedViewDetails: '✓ Connected - View Details',
    declinedClickToChange: '✗ Declined - Click to Change',
    completedViewDetails: '✓ Completed - View Details',
    clickToAccept: 'Click to Accept',
  },
  validation: {
    endTimeTooEarly: 'End time must be at least 10 minutes after start time',
    selectActivity: 'Please select at least one activity',
  },
  calendar: {
    chooseYourCalendarProvider: 'Choose your calendar provider:',
    with: 'with',
    interest: 'interest',
    interests: 'interests',
    oneOnOneConnect: '1-on-1 Connect',
    groupActivity: 'Group Activity',
    matchingInterestsLabel: 'Matching interests:',
    matchingInterestsDescription:
      'You have {interestNames} as matching {interestText} with {firstName}.',
    // Calendar integration
    calendarIntegration: 'Calendar Integration',
    calendarIntegrationDescription:
      'Automatically sync Hubbl events and deadlines to your calendar.',
    calendarIntegrationProgressDescription:
      "Click to view team members' calendar integration status",
    connected: '✓ Connected',
    notConnected: 'Not Connected',
    connectedTo: 'Connected to {provider}',
    googleCalendar: 'Google Calendar',
    connectedOn: 'Connected on {date}',
    connectCalendarDescription:
      'Connect your calendar to automatically sync events, invitations, and RSVP deadlines.',
    noManualDownloads: 'Events and deadlines sync automatically',
    eventsAppearInstantly: 'Invitations appear instantly in your calendar',
    eventsAppearInstantlyAttend:
      'Event invitations, RSVP deadlines, and confirmed events will be added to your calendar automatically.',
    calendarConnectedSuccessfully: 'Calendar connected successfully!',
    connecting: 'Connecting...',
    connectGoogleCalendar: 'Connect Google Calendar',
    connectOutlookCalendar: 'Connect Microsoft Outlook',
    disconnecting: 'Disconnecting...',
    disconnect: 'Disconnect',
    disconnectConfirmation:
      'Are you sure you want to disconnect your calendar? Future events will no longer be added automatically.',
    failedToConnectCalendar: 'Failed to connect calendar',
    failedToDisconnectCalendar: 'Failed to disconnect calendar',
    popupBlocked: 'Popup Blocked',
    popupBlockedDescription:
      'Your browser blocked the calendar connection popup. Click continue to proceed with the connection in this window.',
    continueHere: 'Continue',
    connectingYourCalendar: 'Connecting your calendar...',
    pleaseWaitConnection: 'Please wait while we complete the connection.',
    calendarConnectedTitle: 'Calendar Connected!',
    eventsWillSyncAutomatically:
      'Event invitations and deadlines will now sync automatically to your calendar.',
    returnToSettings: 'Return to Settings',
    connectionFailed: 'Connection Failed',
    close: 'Close',
    connectYourProvider: 'Connect Your {provider}?',
    eventsWillSyncWhenAttend:
      'Event invitations and RSVP deadlines will automatically sync to your calendar. You still need to respond in Hubbl.',
    skipForNow: 'Skip for now',
    connectProvider: 'Connect {provider}',
    calendarConnectedEventsSync:
      '✓ Calendar connected! Events will sync automatically.',
    calendarConnectedSyncAutomatically:
      'Calendar connected - events sync automatically',
    failedToConnectTryAgain: 'Failed to connect calendar. Please try again.',
  },
  user: {
    noDepartment: 'No Department',
    noSubCompany: 'No Sub Company',
    noLocation: 'No Location',
  },
  hubbl: {
    recurringDescription:
      'This will create a repeating 1-on-1 hubbl that colleagues can join weekly.',
    howItWorks:
      "How it works: Your 1-on-1 will be visible to colleagues who can then accept to join you. You'll be matched with whoever accepts first, and you'll receive a notification to coordinate the details.",
  },
  onboarding: {
    describeYourself: 'Describe yourself',
  },
  profileCompletion: {
    cardTitle: 'Complete your profile',
    cardDescription: 'Help colleagues get to know you better',
    completed: 'completed',
    completeNow: 'Complete now',
    addPhoto: 'Add a profile photo',
    addInterests: 'Add at least 5 interests',
    photo: 'profile photo',
    interests: 'interests',
    bannerTitle: 'Your profile is incomplete',
    bannerMessage: 'Add your {items} to help colleagues connect with you',
    completeProfile: 'Complete profile',
  },
  errors: {
    somethingWentWrong: 'Something went wrong',
    invalidCredentials: 'Invalid credentials',
    accessDenied: 'Access denied',
    permissionDenied: 'Permission denied',
    networkError: 'Network error',
    serverError: 'Server error',
    unknownError: 'Unknown error',
    notFound: 'Not Found',
    notAvailable: 'Not Available',
    loading: 'Loading...',
    error: 'Error',
  },
  messages: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    noData: 'No data available',
    noResults: 'No results found',
    tryAgain: 'Try again',
    somethingWentWrong: 'Something went wrong',
    invalidCredentials: 'Invalid credentials',
    accessDenied: 'Access denied',
    permissionDenied: 'Permission denied',
    networkError: 'Network error',
    serverError: 'Server error',
    unknownError: 'Unknown error',
  },
  scenes: {
    event: {
      visibleFor: 'Event visible for:',
      scanToDownloadApp: 'Scan to download app',
      youAttending: "✅ You're attending! ",
      youDeclined: "❌ You've declined this event",
      registerForEvent: 'Register for event',
      processing: 'Processing {action}...',
      youAlreadyReacted: 'You have already reacted to this event',
      deadlinePassed: 'The deadline for this event has passed',
      eventAlreadyPassed: 'This event has already passed',
      reviewEvent: 'Review event',
      thankYouForReview: 'Thank you for your review {emoji}',
      eventHasPassed: 'Event has passed',
      deadlineHasPassed: 'Deadline has passed',
      leaveEvent: 'Leave event',
      changeResponse: 'Change response',
      joinEvent: 'Join event',
      declineEvent: 'Decline',
      colleaguesAttending: 'Colleagues are attending',
    },
    onboarding: {
      pickInterests:
        'Pick up to {maxInterests} interests that describes you as a person, so you can share a little about yourself.',
      saving: 'Saving...',
      saveInterests: 'Save ({count}/{maxInterests}) interests',
      selectToContinue: 'Select {remaining} to continue',
      interestsWhyWeNeedThis: 'Why do we need this?',
      interestsBenefitTitle: 'How this helps you and your team',
      interestsBenefitEmployee:
        '✨ For you: Get invited to activities that match your interests and connect with colleagues who share your passions',
      interestsBenefitManagement:
        '🎯 For company events: Your company uses this to plan better, more relevant events that people actually want to attend',
      interestsSkipConfirmTitle: 'Skip interest selection?',
      interestsSkipConfirmMessage:
        'You can always add your interests later to help us create better events for you and find colleagues with similar interests.',
      interestsSkipForNow: 'Skip for now',
      interestsSkipConfirmButton: 'Skip for now',
      interestsSkipCancelButton: 'Continue selecting',
      interestsSkippedWelcomeBack: 'Welcome back! 👋',
      interestsSkippedDescription:
        "Last time you skipped adding interests. Take a moment to add them now so we can recommend activities you'll love and help plan events tailored to you.",
      addProfilePhoto: 'Add a profile photo',
      helpColleaguesRecognize:
        'Help your colleagues recognize you by adding a profile photo.',
      uploading: 'Uploading...',
      finish: 'Finish',
      skipForNow: 'Skip for now',
      areYouSureNoPhoto: "Are you sure you don't want a profile photo?",
      thisIsHowPeopleRecognize:
        'This is how people around you can recognize you.',
      yesSkip: 'Yes, skip',
      noGoBack: 'No, go back',
      describeYourself: 'Describe yourself',
    },
    createEvent: {
      enterEventTitle: 'Enter event title',
      enterEventLocation: 'Enter event location',
      uploadCoverImage: 'Have to upload a cover image',
      editVisibility: 'Edit visibility',
      additionalInviteOptions: 'Additional Invite Options',
      addQuestions: 'Add questions',
      createQuestion: 'Create Question',
      enableEventEvaluation: 'Enable Event Evaluation',
      addEvaluationQuestions: 'Add evaluation questions',
      addEvaluationReminder: 'Add Evaluation Reminder',
      addReminder: 'Add Reminder',
      enableQRTickets: 'Enable QR tickets for attendees',
      createEvent: 'Create Event',
      // New translations for hardcoded text
      eventDetails: '1. Event Details',
      eventTitle: 'Event Title',
      eventDescription: 'Event Description',
      eventEmoji: 'Event Emoji',
      eventLocation: 'Event Location',
      coverImage: 'Cover Image',
      schedulingDeadline: '2. Scheduling & deadline',
      startDateTime: 'Start Date & Time',
      endDateTime: 'End Date & Time',
      publishDateTime: 'Publish Date & Time',
      deadlineQuestion: 'Want to add a deadline for when to reply?',
      visibilitySection: '3. Who can see this event?',
      noAdditionalInvites: 'No additional invites',
      inviteMyUsers: 'Also invite employees you have invited',
      inviteAllUsers: 'Also invite all invited employees',
      preAttendanceForm: '4. Pre-attendance Form',
      preAttendanceQuestions: 'Questions to ask before attendance',
      postEventEvaluation: '5. Post-event Evaluation',
      evaluationIntroduction: 'Introduction',
      evaluationQuestions: 'Evaluation questions',
      evaluationEndDate: 'Evaluation End Date',
      evaluationRemindersDefault:
        'Evaluation Reminders (defaults to day and week after event)',
      notifications: '6. Notifications',
      eventRemindersDefault:
        'Event Reminders (defaults to week and day before)',
      qrTicketSystem: '7. QR Ticket System',
      qrTicketsEnabled:
        'Admins will get access to a QR code scanner and attendees will get a QR code to be able to check.',
      qrTicketsDisabled: 'QR tickets are disabled for this event.',
      // Event tags
      eventTags: 'Event tags',
      addTagPlaceholder: 'Add tag and press Enter or comma...',
      tags: 'Tags',
      searchPlaceholder:
        'Search events by title, location, tags, or description...',
      // Validation messages
      eventTitleRequired: 'Event title cannot be blank',
      eventDescriptionRequired: 'Event description cannot be blank',
      emojiRequired: 'You have to select an emoji',
      eventLocationRequired: 'Event location cannot be blank',
      startDateTimeRequired: 'Start date and time cannot be blank',
      startDateTimeInPast: 'Start date and time cannot be in the past',
      endDateTimeBeforeStart: 'End date cannot be before start date',
      deadlineAfterStart: 'Deadline cannot be after start date time',
      publishDateTimeRequired: 'Publish date and time cannot be blank',
      evaluationEndDateRequired: 'Evaluation end date cannot be blank',
      reminderTimeRequired: 'Reminder time is required',
      evaluationEnabledAddQuestion:
        'Evaluation is enabled, please add at least one question.',
      fillRequiredFields:
        'Please fill in all required fields before creating an event.',
      selectStartDateReminder:
        'Please select a start date before adding a reminder.',
      selectEndDateEvaluationReminder:
        'Please select an end date before adding an evaluation reminder.',
      // Default evaluation description
      defaultEvaluationDescription:
        'Please take a moment to evaluate the event {eventTitle}. Your feedback helps us improve future events! 📝',
      // Question management
      editQuestion: 'Edit question',
      addNewQuestion: 'Add new question',
      writeQuestionHere: 'Write your question here',
      questionType: 'Question Type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      freeText: 'Free Text',
      options: 'Options',
      enterOptionHere: 'Enter option {number} here',
      optionCannotBeEmpty: 'Option cannot be empty',
      questionTextCannotBeEmpty: 'Question text cannot be empty',
      allowFreeTextAnswer: 'Allow free text answer',
      questionIsRequired: 'Question is required',
      changesSavedSuccessfully: 'Changes saved successfully!',
      questionAddedSuccessfully: 'Question added successfully!',
      saveChanges: 'Save changes',
      saveQuestion: 'Save question',
      cancel: 'Cancel',
      // Evaluation question management
      editEvaluationQuestion: 'Edit evaluation question',
      addNewEvaluationQuestion: 'Add new evaluation question',
      // Chart tooltips and descriptions
      totalSelections: 'total selections',
      users: 'users',
      ofTotalUsers: 'of total users',
      categoryBreakdownDescription:
        'Shows the distribution of interest selections across different categories. Each category represents a group of related interests.',
      // Draft management
      draftUpdatedSuccessfully: 'Draft updated successfully',
      draftSavedSuccessfully: 'Draft saved successfully',
      pleaseEnterEventTitleToSaveDraft:
        'Please enter an event title to save as draft',
      draftDeletedSuccessfully: 'Draft deleted successfully',
      deleteDraftTitle: 'Delete Draft',
      deleteDraftMessage:
        'Are you sure you want to delete "{title}"? This action cannot be undone.',
      saveDraft: 'Save draft',
      savingDraft: 'Saving...',
      loadDraft: 'Load draft',
      // Image upload
      onlyImageFilesAllowed: 'Only JPG, JPEG, or PNG files are allowed.',
      fileSizeExceedsLimit: 'File size exceeds 5MB.',
      failedToUploadImage: 'Failed to upload image.',
      imageSelected: 'Image selected: {filename}',
      loading: 'Loading...',
      dragAndDropImage: 'Drag and drop an image here, or click to select',
      // Events overview
      eventsOverview: 'Events Overview',
      eventsOverviewDescription:
        'Here, you can get an overview of all events at {companyName}.',
      created: 'Created',
      event: 'Event',
      startDate: 'Start Date',
      publishDate: 'Publish Date',
      rsvpDeadline: 'RSVP Deadline',
      attendees: 'Attendees',
      declined: 'Declined',
      questions: 'Questions',
      status: 'Status',
      upcoming: 'Upcoming',
      completed: 'Completed',

      loadingMoreEvents: 'Loading more events...',
      dash: '—',
      sortAscending: '↑',
      sortDescending: '↓',
      noEvents: 'No events yet',
      noEventsDescription:
        'Get started by creating your first event. Events help bring your team together and foster connections.',
      noSearchResults: 'No events found',
      noSearchResultsDescription:
        "Try adjusting your search terms or filters to find what you're looking for.",
      // Response rate
      responseRate: 'Response Rate',
      ofEmployeesResponded: 'of {totalCount} employees responded',
      sendManualEmail: 'Send Manual Email',
      increaseResponseRate: 'Increase the response rate',
      declinedUsers: 'Declined Users',
      qrCodeCheckInStatus: 'QR Code Check-in Status',
      checkedIn: 'Checked in',
      notCheckedIn: 'Not checked in',
      qrCodesEnabled: 'QR codes are enabled for this event',
      emailReminderSubject: 'Reminder: {eventTitle} {eventEmoji}',
      emailReminderBody:
        'Hi,\n\nThis is a friendly reminder about the event "{eventTitle}" {eventEmoji}.\n\nPlease respond to the event invitation.\n\nBest regards,\n{adminName}',
      // Heatmap and analytics
      interestRate: 'Interest Rate:',
      selected: 'Selected',
      // Draft manager
      errorReadingFile: 'Error reading file',
      errorConvertingBase64ToFile: 'Error converting base64 to file:',
      emptyImageFilename: 'empty.jpg',
      coverImageFilename: 'cover-image.jpg',
      // Question Bank
      questionBank: 'Question Bank',
      questionBankDescription: 'Select a question to add it to your event',
      standardQuestions: 'Standard Questions',
      companySavedQuestions: 'Saved Questions',
      savedQuestions: 'Saved Questions',
      noSavedQuestions: 'No saved questions yet. Save questions when creating them to build your question bank.',
      loadFromBank: 'Load from Question Bank',
      standardTag: 'Standard',
      savedTag: 'Saved',
      editSavedQuestion: 'Edit Saved Question',
      editSavedQuestionNotice: 'Changes will update this question in your company question bank.',
      saveToQuestionBank: 'Save to Question Bank',
      editBankQuestion: 'Edit Bank Question',
      updateBankQuestion: 'Update Bank Question',
      bankQuestionUpdated: 'Bank question updated',
      questionDeletedSuccessfully: 'Question deleted from bank',
    },
    colleaguesOverview: {
      loadingTeamMembers: 'Loading team members...',
      noTeamMembersFound:
        'No team members found. Please try refreshing the page.',
      discoverColleagues: 'Discover your colleagues at {companyName}',
      yourCompany: 'your company',
      discoverFilteredColleagues:
        'Discover your {filteredCount} of {totalCount} colleagues at {companyName}',
      deleteUser: 'Delete user',
      deleteUserConfirmTitle: 'Delete user?',
      deleteUserConfirmMessage:
        'Are you sure you want to permanently delete {userName}? This action cannot be undone.',
      deleteUserSuccess: 'User deleted successfully',
      deleteUserError: 'Failed to delete user',
      deleting: 'Deleting...',
      actions: 'Actions',
    },
    userProfile: {
      userNotFound: 'User not found',
      failedToLoadUser: 'Failed to load user details',
    },
    getStarted: {
      whatDescribesSituation: 'What describes your situation the best?',
      useInWorkplace: 'I want to use Hubbl within my workplace',
      manageCoworkingSpace:
        'I manage a coworking space and want to use Hubbl with the coworkers',
      useInUniversity: 'I want to use Hubbl within my university',
      manageIncubator:
        'I manage an incubator and want to use Hubbl amongst the start-ups',
      inviteYourTeam: 'Invite your team',
      addEmployeesViaCSVDescription:
        'Add employees via CSV upload or manually. You can also skip and invite them later.',
      csvFormatDescription: 'CSV format: email, fullName, department, jobTitle',
      orAddEmployeesManually: 'Or add employees manually:',
      setupYourCompany: "Let's set up your company on Hubbl",
      setupYourCompanyDescription: 'Tell us a bit about you and your company',
      yourFullName: 'Your full name',
      companyName: 'Company name',
      readyToLaunch: 'Ready to launch!',
      readyToLaunchDescription:
        'Review your company details and click create to get started',
      summary: 'Summary',
      admin: 'Admin',
      employeesToInvite: 'Employees to invite',
      createCompany: 'Create Company',
      creatingCompany: 'Creating your company...',
      employee: 'employee',
      employees: 'employees',
    },
    createHubbl: {
      inviteColleagues: 'Invite colleagues',
      inviteColleaguesDescription:
        'Invite specific colleagues to this activity',
      addInvitations: 'Add invitations',
      inviting: 'Inviting {name}',
      invitingCount: 'Inviting {count} colleagues',
      youInviting: "You're inviting {name}",
      youInvitingCount: "You're inviting {count} colleagues",
      whoCanSee: 'Who can see this activity?',
      whoCanSeeDescription: 'Choose which colleagues will see this activity',
      everyone: 'Everyone',
      allDepartments: 'All departments',
      filters: '{count} filter{plural}',
      departments: '{count} departments',
      createHubbl: 'Create a Hubbl',
      createHubblDescription:
        'Connect with colleagues across teams, discover shared interests, and build meaningful workplace relationships',
      hubblConnect: 'Hubbl Connect',
      hubblConnectDescription:
        'Connect one-on-one with colleagues who share your interests for coffee, lunch, or any activity',
      hubblGroup: 'Hubbl Group',
      hubblGroupDescription:
        'Create group activities that bring colleagues together around shared interests and hobbies',
      findColleagues: 'Find colleagues with similar interests',
      breakDownSilos: 'Break down team silos',
      flexibleScheduling: 'Flexible scheduling',
      discoverPerspectives: 'Discover new perspectives',
      findYourPeople: '🎯 Find your people',
      findYourPeopleDescription:
        'Connect with colleagues who share your passions and interests',
      connectAcrossDepartments: 'Connect across departments',
      sharePassions: 'Share your passions with others',
      meetNewColleagues: 'Meet new colleagues',
      buildFriendships: 'Build lasting friendships',
      expandNetwork: '🌟 Expand your network',
      expandNetworkDescription:
        'Meet colleagues from different teams who share your interests',
      connectionsDisabled: '1-on-1 Connects are currently disabled',
      groupsDisabled: 'Group activities are currently disabled',
      activityDetails: 'Activity Details',
      whatActivityOrganize: 'What activity would you like to organize?',
      activityPlaceholder: 'e.g., Coffee break, Team lunch, Walking meeting',
      activityRequired: 'Activity is required',
      locationOptional: 'Location (optional)',
      locationPlaceholder: 'e.g., Main office, Conference room A, Local café',
      additionalDetails: 'Additional Details (optional)',
      additionalDetailsPlaceholder:
        'Any additional information participants should know...',
      endOptional: 'End (optional)',
      startRequired: 'Start date and time is required',
      makeRecurring: 'Make this a recurring activity',
      recurringDescription:
        'This will create a repeating group activity that colleagues can join weekly.',
      howItWorks:
        "How it works: Your group activity will be visible to colleagues who can then join. You'll receive notifications when people join, and you can coordinate the details together.",
      addTasks: 'Add tasks',
      tasksDescription:
        'Do you need to deligate any tasks amongst other colleagues to organize this event?',
      tasksOptional: 'Tasks (optional)',
      cancel: 'Cancel',
      createActivity: 'Create Activity',
      creating: 'Creating...',
      endTimeValidationError:
        'End time must be at least 10 minutes after start time',
      activityRequiredError: 'Activity is required',
      startDateTimeRequiredError: 'Start date and time is required',
    },
    activity: {
      youCreatedWaiting: 'You created this - Waiting for someone to join',
      connected: '✓ Connected',
      clickToAccept: 'Click to Accept',
      completed: '✓ Completed',
      declinedClickChange: '✗ Declined - Click to Change',
      decline: 'Decline',
      leave: 'Leave',
      chatNotAvailable: 'Chat not available',
      needToAcceptConnect:
        'You need to accept this Connect to access the chat.',
      needToJoinGroup: 'You need to join this group to access the chat.',
      comingSoon: 'Coming Soon',
      downloadApp: 'Download App',
      scanQRCode: 'Scan QR Code',
      downloadToCalendar: 'Download to calendar',
      interestsInCommon: '👋 Interests you both have in common',
      groupAttendees: 'Group Attendees',
      clickToSeeAll: 'Click to see all attendees',
      moreAttendees: '+{count} more',
      details: 'Details',
      tasks: 'Tasks',
      chat: 'Chat',
      chatWith: 'Chat with {name}',
      created: 'Created {date}',
      waitingForOthers: 'Waiting for others to join',
      acceptedYour: '{name} accepted your Hubbl Connect',
      youCreated: '{activity} you created',
      with: '{activity} with {name}',
      waitingForSomeone: 'Waiting for someone to join',
      connectedViewDetails: 'Connected - View Details',
      completedViewDetails: 'Completed - View Details',
      connectNotFound: 'Connect not found',
      tasksNotAvailable: 'Tasks not available',
      needToAcceptConnectTasks:
        'You need to accept this Connect to access the tasks.',
      declineConnect: 'Decline',
      declineConnectMessage: 'Are you sure you want to decline this Connect?',
      keepInvitation: 'Keep Invitation',
      loading: 'Loading...',
    },
    table: {
      avatar: 'Avatar',
      nameTitle: 'Name & Title',
      department: 'Department',
      company: 'Company',
      officeLocation: 'Office Location',
      started: 'Started',
      calendarIntegration: 'Calendar',
      funFact: 'Fun Fact',
      interests: 'Interests',
      clickToViewProfile: 'Click to view profile',
      na: 'N/A',
      cards: 'Cards',
      table: 'Table',
    },
    profile: {
      userProfile: 'User Profile',
      loadingUserProfile: 'Loading user profile...',
      interests: '🎯 Interests',
      matchingInterests: '👋 Matching Interests with you',
      more: '+{count} more',
      department: 'Department',
      company: 'Company',
      officeLocation: 'Office Location',
      startedAtCompany: 'Started at Company',
      funFact: '💡 Fun Fact',
      inviteToHubbl: 'Invite {name} to a Hubbl (coming soon)',
    },
    dashboard: {
      welcomeBack: 'Welcome back, {name}! 👋',
      upcomingActivities:
        "Here's your upcoming social activities at {companyName}",
      loadingSocialActivities: 'Loading your social activities...',
      socialActivities: 'Social Activities',
      noSocialActivities: 'No social activities found',
      noActivitiesMatchFilters: 'No activities match your current filters',
    },
    pastEvents: {
      previousEvents: 'Previous Events',
      completeTimeline: 'Complete timeline of past events',
      loadingPreviousEvents: 'Loading your previous events...',
      loadPreviousEvents: 'Load previous events',
      noPreviousEvents: 'No previous events found',
      noPastEventsToDisplay:
        'There are no past events to display at the moment.',
    },
    deadline: {
      rsvpWithin: 'RSVP within {time} {unit}',
      deadlinePassed: 'Deadline passed',
      leftToRespond: 'Left to respond',
      deadline: 'Deadline: {time}',
    },
    ticket: {
      yourEventTicket: 'Your event ticket',
      checkedInAt: '✅ Checked in at {time}',
    },
    eventEndpoint: {
      eventNotFound: 'Event not found',
      eventNotFoundOrUnauthorized: 'Event not found or unauthorized',
      accessDenied: 'You do not have access to this event',
      attendees: 'Attendees ({count})',
    },
    auth: {
      signInWithGoogle: 'Sign in with Google',
      youDontHaveAccess: "You don't have access to this app",
      failedToSetupAccount: 'Failed to set up your account. Please try again.',
      youDontHaveAccessToApp: "You don't have access",
      failedToAssociateUser:
        'Failed to associate user with company after retries',
      failedToMoveUser: 'Failed to move user to company after retries',
    },
    slack: {
      noOrganizationalStructure: 'No Organizational Structure',
      ssoNotEnabled: 'SSO integration may not be enabled for this company.',
      noSubCompaniesFound: 'No Sub-Companies Found',
      noSubCompaniesInStructure:
        'No sub-companies found in the organizational structure.',
      subCompanySlackChannels: 'Sub-Company Slack Channels',
      configureSlackWebhooks:
        'Configure Slack webhook URLs for each sub-company to enable targeted notifications. Each sub-company can have its own dedicated Slack channel for event updates.',
      slackWebhookUrl: 'Slack Webhook URL',
      noSlackWebhookConfigured: 'No Slack webhook configured',
      edit: 'Edit',
      saving: 'Saving...',
      save: 'Save',
      cancel: 'Cancel',
      savedSuccessfully: '✓ Saved successfully!',
      failedToSave:
        '✗ Failed to save. Please double check the URL and try again.',
      slackIntegration: 'Slack Integration',
      configureSlackIntegration:
        'Configure your Slack integration to receive event notifications and updates. Set up general settings and configure specific channels for each sub-company.',
      general: 'General',
      nothingHereYet: 'Nothing here yet.',
      sendSlackNotification: 'Send Slack Notification',
      slackNotificationSent: 'Slack notification sent successfully!',
      failedToSendSlackNotification:
        'Failed to send Slack notification. Please try again.',
      sendSlackNotificationConfirmTitle: 'Send Slack Notification',
      sendSlackNotificationConfirmMessage:
        'Are you sure you want to send a Slack notification again for this event? This will send a message to relevant Slack channels.',
      sendSlackNotificationConfirm: 'Send Notification',
    },
    integrations: {
      noOrganizationalStructure: 'No Organizational Structure',
      ssoNotEnabled: 'SSO integration may not be enabled for this company.',
      noSubCompaniesFound: 'No Sub-Companies Found',
      noSubCompaniesInStructure:
        'No sub-companies found in the organizational structure.',
      subCompanyChannels: 'Sub-Company {integration} Channels',
      configureWebhooks:
        'Configure {integration} webhook URLs for each sub-company to enable targeted notifications. Each sub-company can have its own dedicated channel for event updates.',
      webhookUrl: 'Webhook URL',
      noWebhookConfigured: 'No webhook configured',
      savedSuccessfully: '✓ Saved successfully!',
      failedToSave:
        '✗ Failed to save. Please double check the URL and try again.',
      configureIntegrations:
        'Configure your integrations to receive event notifications and updates.',
      slack: 'Slack',
      teams: 'Microsoft Teams',
      deleteIntegration: 'Delete integration',
      deleteIntegrationConfirmTitle: 'Delete integration?',
      deleteIntegrationConfirmMessage:
        'This will remove all webhook configurations. You will need to reconfigure everything if you want to use integrations again.',
      deleteIntegrationConfirm: 'Yes, Delete All',
      choosePlatformTitle: 'Choose Your Integration Platform',
      choosePlatformDescription:
        'Select which communication platform you want to use for event notifications. You can configure webhooks after selecting a platform.',
      slackDescription: 'Send event notifications to Slack channels',
      teamsDescription: 'Send event notifications to Teams channels',
    },
    adminManagement: {
      title: 'Admin Management',
      description:
        'Manage administrator privileges for your team. Promote employees to admins or local admins.',
      currentAdmins: 'Current Administrators',
      currentAdminsDescription:
        'These users have full administrative access to manage events, analytics, and settings.',
      currentLocalAdmins: 'Local Administrators',
      currentLocalAdminsDescription:
        'These users have limited administrative access for their area.',
      promoteEmployees: 'Promote Employees',
      promoteEmployeesDescription:
        'Search and promote employees to grant them administrative privileges.',
      noAdmins: 'No administrators found',
      noLocalAdmins: 'No local administrators found',
      noEmployees: 'No employees to promote',
      searchEmployees: 'Search employees...',
      promote: 'Promote',
      promoteToAdmin: 'Promote to Admin',
      promoteToLocalAdmin: 'Promote to Local Admin',
      demote: 'Remove Privileges',
      promoting: 'Promoting...',
      demoting: 'Removing...',
      promotedSuccessfully: 'User privileges updated successfully',
      demotedSuccessfully: 'User privileges successfully removed',
      cannotDemoteLastAdmin:
        'Cannot demote the last admin. There must be at least one admin in the company.',
      confirmDemote: 'Confirm Privilege Removal',
      confirmDemoteMessage:
        'Are you sure you want to remove privileges from {name}? They will lose access to admin features.',
      confirmPromote: 'Confirm Promotion to Admin',
      confirmPromoteMessage:
        'Are you sure you want to promote {name} to admin? They will gain access to all admin features including event management, analytics, and company settings.',
      confirmPromoteToLocalAdmin: 'Confirm Promotion to Local Admin',
      confirmPromoteToLocalAdminMessage:
        'Are you sure you want to promote {name} to local admin? They will gain limited administrative access.',
      errorPromoting: 'Failed to update user privileges. Please try again.',
      errorDemoting: 'Failed to remove user privileges. Please try again.',
      cannotDemoteSelf:
        'You cannot demote yourself. Ask another admin to remove your privileges.',
      localAdminComingSoon: 'Local admin management is coming soon!',
      comingSoon: '(Coming Soon)',
      loadingAdmins: 'Loading administrators...',
      loadingEmployees: 'Loading employees...',
      admin: 'Admin',
      localAdmin: 'Local Admin',
      employee: 'Employee',
      you: '(You)',
    },
  },
};

export default language;
